import clsx from 'clsx'

import s from '../styles.module.scss'

interface FlightDetailsProps {
  duration: string
  transfers: string
  isNightTransfer?: boolean
}

export const FlightDetails = ({
  duration,
  transfers,
  isNightTransfer = false,
}: FlightDetailsProps) => (
  <div className={s.flightDetails}>
    <span className={clsx('medium-14', s.flightDuration)}>{duration}</span>
    <span
      className={clsx(
        'medium-12',
        s.flightTransfers,
        isNightTransfer && s.nightTransfer,
      )}
    >
      {transfers}
    </span>
  </div>
)
